import { View as Flex } from '@react-pdf/renderer';

import { Page } from '../../../components/pdf-export/Page/Page.js';
import { Table } from '../../../components/pdf-export/Table/Table.js';
import { Td } from '../../../components/pdf-export/Td/Td.js';
import { Text as Typography } from '../../../components/pdf-export/Text/Text.js';
import { Tr } from '../../../components/pdf-export/Tr/Tr.js';
import { Document as PDFDocument } from '../../../summary/Document.js';
import { CostApproachSummary } from '../CostApproachSummary/CostApproachSummary.js';
import { Tkv2PairedCostSummaryInterfaceV2 } from '../types.js';

const pdfRenderDeps = { Flex, Table, Td, Tr, Typography };

export const CostApproachExport = (props: Tkv2PairedCostSummaryInterfaceV2) => {
  return (
    <PDFDocument>
      <Page title="Cost Approach to Value">
        <Flex>
          <CostApproachSummary {...props} {...pdfRenderDeps} />
        </Flex>
      </Page>
    </PDFDocument>
  );
};
